
import { Options, Vue } from "vue-class-component";

import PhotoListHome from "@/components/PhotoListHome.vue"

import { useCategoryStore } from "@/stores/category";
import { usePhotoStore } from "@/stores/photo";
import { useLanguageStore } from "@/stores/language"

import {
  STATUS_API_CALL,
  TEXT_KEYS } from '@/constants'

import { PhotoApi } from "@/api/photo-api"

@Options({
  components: {
    PhotoListHome
  }
})
export default class PhotosHome extends Vue {
  categoryStore = useCategoryStore()
  photoStore = usePhotoStore()
  languageStore = useLanguageStore()

  photoIdSelected = -1

  TEXT_KEYS = TEXT_KEYS
  STATUS_API_CALL = STATUS_API_CALL

  apiStatus = STATUS_API_CALL.IDLE

  photos: Record<string, any>[] = []

  api = new PhotoApi()

  mounted() {
    console.log("PhotosHome")

    this.getPhotos()
  }

  async getPhotos() {
    console.log("getPhotos")

    try {
      this.photos = []

      this.apiStatus = STATUS_API_CALL.RUNNING

      const response: any = await this.api.getHome()
      console.log('data', response)

      this.photos = response.data
    } catch(error) {
      console.error('getPhotos', error)

      this.apiStatus = STATUS_API_CALL.FAILED
    } finally {
      this.apiStatus = STATUS_API_CALL.IDLE
    }
  }
}
